import { GlobalVariables } from "./constants";

export const Apis = {
  //USER APIS
  ALL_USERS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-all`,
  SIGN_IN:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/authenticate`,
  USER_ROLE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/user/userrole`,
  USER_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/user/usertype`,
  ADD_USER:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-add`,
  GET_USER:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-get`,
  DELETE_USER:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-delete`,
  UPDATE_USER:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-update`,
    BUSINESS_UNIT:
  GlobalVariables.API_BASE_URL +
  `/a/api/efm/v1/${
    GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
  }/reference/user/businessunit`,
  RESET_PASSWORD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-reset-password`,
  SET_PASSWORD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-set-password`,
  CHANGE_PASSWORD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-change-password`,
  FORGOT_PASSWORD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-forget-password`,
  USER_STATUS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/user/userstatus`,
  UPDATE_PASSWORD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-update-password`,
  GENERATE_OTP:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-generate-otp`,
  VERIFY_OTP:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-validate-otp`,
  REFRESH_TOKEN:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/refreshaccesstoken`,
  USER_SEARCH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-search`,
  SET_SSH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-set-sshkey`,
  UPDATE_SSH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-update-sshkey`,
  RESET_SSH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/user-reset-sshkey`,
  GET_AUTHURL:
    GlobalVariables.API_BASE_URL +    
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/user/initiateauth`,
  //Audit-Log
  AUDIT_SEARCH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reporting/audit-search`,
  AUDIT_DETAILS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reporting/audit`,
  AUDIT_EXPORT:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reporting/audit-export`,    

  //Business Unit
  GET_ALL_BUSINESSUNITS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-all`,
    GET_ALL_BUSINESSUNITVALUES:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-all-values`,
  GET_BUSINESSUNIT:
    GlobalVariables.API_BASE_URL +    
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-get`,
  ADD_BUSINESSUNIT:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-add`,
  UPDATE_BUSINESSUNIT:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-update`,
  DELETE_BUSINESSUNIT:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-delete`,
  BUSINESSUNIT_SEARCH:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/businessunit-search`,
  BUSINESSUNIT_STATUS:
    GlobalVariables.API_BASE_URL +      
      `/a/api/efm/v1/${
        GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
      }/reference/businessunit/businessunit-status`,
      JHID_EXCHANGE_TOKEN:
      GlobalVariables.API_BASE_URL +
      `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
      }/user/exchangeauthorizationcode`,
  //Institution
  INSTITUTION_ALL:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/institution/institution-all`,
  INSTITUTION_GET:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/institution/institution-get`,
  INSTITUTION_ADD:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/institution/institution-add`,
  INSTITUTION_UPDATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/institution/institution-update`,
  INSTITUTION_DELETE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/businessunit/institution/institution-delete`,

  //Workflow
  ADD_WORKFLOW:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-add`,
  GET_WORKFLOW:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-get`,
  UPDATE_WORKFLOW:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-update`,
  DELETE_WORKFLOW:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-delete`,
  WORKFLOW_LIST:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-search`,
  WORKFLOW_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
        }/reference/workflow/transfertype`,
  GET_WORKFLOW_CLONE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
        }/workflow/workflow-clone-get`,
  ADD_WORKFLOW_CLONE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
        }/workflow/workflow-add-clone`,
  FUNCTION_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/workflow-step`,
  SOURCE_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/filestorage`,
  NOTIFICATION_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/notificationtype
  `,
  NOTIFICATION_MESSAGE_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/notificationmessagetype
  `,
  SCHEDULER_TIMEZONE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/timezone
  `,
  SCHEDULER_TYPE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/schedulertype
  `,
  SCHEDULER_RATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/schedulerrate
  `,
  UPDATE_WORKFLOW_STATUS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-update-status`,
  /** POST — PULL on-demand activation (OpCon / Run Workflow Now — Story 1.3). Append /{workflowId}. */
  WORKFLOW_ACTIVATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-activate/`,
  /** POST — SFTP / workflow-step connectivity test (Story 3.3b). Body: step snapshot + testLeg + optional sourceLocationPath. */
  TEST_WORKFLOW_STEP_CONNECTION:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/workflow/workflow-step-test-connection`,
    AWS_REGION_LIST:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${
      GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/reference/workflow/awsregionlist`,

  //Workflow Templates
  // Routes aligned with C# API TemplateController.cs
  GET_ALL_WORKFLOW_TEMPLATES:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-search`, // C# API uses search for listing
  GET_WORKFLOW_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-get`, // Append /{templateName} when calling
  ADD_WORKFLOW_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-create`,
  DELETE_WORKFLOW_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-delete`, // Append /{templateName} when calling
  UPDATE_WORKFLOW_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-update`, // Append /{templateName} when calling
  UPDATE_WORKFLOW_TEMPLATE_STATUS:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-update-status`,
  SEARCH_WORKFLOW_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template/template-search`,
  
  // Generate Workflow from Template
  // C# API: POST /template/{templateName}/template-create-workflow
  // Request body: { VariableValues: Record<string, string>, SourceLocationPath: string, WorkflowName: string }
  // Response: { WorkflowName, SourceLocationPath, Status: "inactive", ETag }
  GENERATE_WORKFLOW_FROM_TEMPLATE:
    GlobalVariables.API_BASE_URL +
    `/a/api/efm/v1/${GlobalVariables?.INSTITUTION_UNIVERSAL_ID ?? ""
    }/template`, // Append /{templateName}/template-create-workflow when calling

}